<template>
    <div class="page flex flex-col md:border-l md:border-r">
        <TopBarBg :headerText="lbl.sidemenu.contact_us" sideMenu></TopBarBg>
        <PageContent class="flex-auto" :hasPoweredBy="hasPoweredBy" rounded>
            <div class="px-5">
                <div class="text-center">
                    <img class="mx-auto" src="@/assets/icon/misc/contact-us-icon.svg">
                    <div class="text-primary text-base mt-5">
                        {{ lbl.contact_us.contact_information }}
                    </div>
                    <div class="text-sm text-gray-secondary mt-2">
                        {{ lbl.contact_us.detail }}
                    </div>
                    <!-- <ButtonEmailMessenger :text="'jcbthailamnd@email.com'"></ButtonEmailMessenger>
                    <div class="flex justify-center">
                        <div class="line-text"></div>
                        <div class="text-primary-50">
                            or
                        </div>
                        <div class="line-text"></div>
                    </div> -->
                    <ButtonFBMessenger :text="lbl.contact_us.fb"></ButtonFBMessenger>
                </div>
            </div>
        </PageContent>
        <!-- <ButtonFBMessenger :text="lbl.faq.fb"></ButtonFBMessenger> -->
        <Footer :hasPoweredBy="hasPoweredBy" />
    </div>
    <div class="flyout-zone">
        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>

<script>
import TopBarBg from "@/components/Layout/TopBar/TopBarBg.vue"
import PageContent from "@/components/Layout/Content/PageContent.vue"
import Footer from "@/components/Layout/Footer/Footer.vue"
import ModalMaster from "@/components/Modal/ModalMaster.vue"
import ButtonFBMessenger from "../component/ButtonFBMessenger.vue"
// import ButtonEmailMessenger from "../component/ButtonEmailMessenger.vue"

// mixin
import ModalMixin from "@/mixin/ModalMixin"
import LocaleMixin from "@/mixin/LocaleMixin"
import ErrorApiMixin from "@/mixin/ErrorApiMixin"
import PdpaMixin from "@/mixin/PdpaMixin";

export default {
    name: "FAQPage",
    mixins: [LocaleMixin, ModalMixin, ErrorApiMixin, PdpaMixin],
    components: {
        TopBarBg,
        PageContent,
        Footer,
        ModalMaster,
        ButtonFBMessenger,
        // ButtonEmailMessenger,
    },
    data: function () {
        return {
            hasPoweredBy: false,
            dialogFAQ: false,
            faqGroup: [
                {
                    key: "something",
                    name: "Lorem ipsum dolor sit amet, consec tetur adipiscing elit.",
                    data: []
                },
                {
                    key: "something",
                    name: "Lorem ipsum dolor sit amet, consec tetur adipiscing elit.",
                    data: []
                },
                {
                    key: "something",
                    name: "Lorem ipsum dolor sit amet, consec tetur adipiscing elit.",
                    data: []
                },
                {
                    key: "something",
                    name: "Lorem ipsum dolor sit amet, consec tetur adipiscing elit.",
                    data: []
                },
                {
                    key: "something",
                    name: "Lorem ipsum dolor sit amet, consec tetur adipiscing elit.",
                    data: []
                },
            ],
            trackingScreenName: 'contact_us',
        }
    },
    created: function () {
        this.tracking.screenName(this.trackingScreenName);
        this.tracking.event('contact_us', 'click_contact_facebook', null, null);
    },
    methods: {
        openDetail: function (key) {
            this.$router.push({
                name: "faq-detail",
                params: {
                    key: key
                }
            })
            // this.dialogFAQ = true
        }
    }
}
</script>
<style scoped>
    .line-text{
        width: 45px;
        height: 1px;
        flex-grow: 0;
        margin: 15px 12px;
        background-color: #e3e8f3;
    }
</style>

